module.exports = __webpack_public_path__ + "3471c7281a0d3ddad94cb77719d46baa.svg";